import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { CompanyInsightsService, WorkOrderTotals } from '../../../domains/company-insights/company-insights.service';

/**
 * TT-260 item 10. Under the Items total: what the work order is worth with its
 * accepted changes, what has been invoiced and what is left. The numbers come
 * from the same calculation that decides when a work order is finished, so the
 * screen and the status can never disagree.
 */
@Component({
  selector: 'gc-work-order-value-summary',
  template: `
    <ion-list *ngIf="totals" lines="none" class="ion-no-padding value-summary" data-cy="work-order-value-summary">
      <ion-item class="ion-no-padding">
        <ion-label class="ion-text-end">Total w/ Changes</ion-label>
        <strong slot="end" data-cy="value-total-with-changes">{{ totals.totalWithChanges | currency }}</strong>
      </ion-item>
      <ion-item class="ion-no-padding">
        <ion-label class="ion-text-end">Invoiced to Date</ion-label>
        <strong slot="end" data-cy="value-invoiced-to-date">{{ totals.invoicedToDate | currency }}</strong>
      </ion-item>
      <ion-item class="ion-no-padding">
        <ion-label class="ion-text-end">Remaining W/O Value</ion-label>
        <strong slot="end" data-cy="value-remaining">{{ totals.remaining | currency }}</strong>
      </ion-item>
      <ion-item *ngIf="totals.pendingChanges" class="ion-no-padding">
        <ion-label class="ion-text-end" color="medium">Change orders waiting for acceptance</ion-label>
        <ion-text slot="end" color="medium" data-cy="value-pending-changes">{{ totals.pendingChanges | currency }}</ion-text>
      </ion-item>
    </ion-list>
  `,
  styles: [
    `
      .value-summary ion-item {
        --min-height: 28px;
        font-size: 14px;
      }
    `,
  ],
})
export class WorkOrderValueSummaryComponent implements OnChanges {
  @Input() workOrderId?: string;

  totals?: WorkOrderTotals;

  constructor(private readonly insights: CompanyInsightsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['workOrderId'] && this.workOrderId) {
      this.insights
        .totals(this.workOrderId)
        .pipe(
          take(1),
          catchError(() => of(undefined)),
        )
        .subscribe(totals => (this.totals = totals));
    }
  }
}
